import React from 'react'
import { useForm } from "react-hook-form";
import { TextField, Button, Stack } from "@mui/material";

const BoardForm = () => {
    const { register, handleSubmit, watch, formState: { errors }, handleChange, control } = useForm();

    const onSubmit = (data) => {
        console.log(data);
    }
    return (
        <>
            <div>


                <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete='off' >
                    <Stack spacing={2}>
                        <h1>Board Form</h1>

                        <TextField name="board_id" label='Board id' {...register("board_id")} />
                        <TextField name="leitungsebene_id" label='Leitungsebene id' {...register("leitungsebene_id")} />

                        {/* <TextField name="year" label='Year' {...register("year")} /> */}

                        <label>Year</label>
                        <input type="number" id='date_started' {...register('year', { valueAsDate: true })} />

                        <TextField name="manager_id" label='Manager id' {...register("manager_id")} />

                        <label htmlFor="notes">Notes:</label>
                        <textarea name="notes" id="notes" {...register('notes')}></textarea>


                        <Button type='submit' variant="outlined">Submit</Button>

                    </Stack>

                </form>


            </div>
        </>
    )
}

export default BoardForm